var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('contract.prices.headline')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('contract.prices.paragraph_one'))}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('contract.prices.paragraph_two')))]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/eneforhandler/components/contract/PricesOutput.vue?vue&type=template&id=7b78a5a8&
// module id = null
// module chunks = 